
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DepartmentMasterGrid extends Serenity.EntityGrid<DepartmentMasterRow, any> {
        protected getColumnsKey() { return 'OMS.DepartmentMaster'; }
        protected getDialogType() { return DepartmentMasterDialog; }
        protected getIdProperty() { return DepartmentMasterRow.idProperty; }
        protected getInsertPermission() { return DepartmentMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return DepartmentMasterRow.localTextPrefix; }
        protected getService() { return DepartmentMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}